<main #mainElement (mousedown)="setClick($event)" class="w-full show">
	<lbca-input-text-rounded
		[disabled]="isDisabled"
		[readonly]="isReadOnly"
		[data]="dataInput"
		[chosed]="chosed"
		[tabeled]="isTabeled"
		[editable]="isEditable"
		[showErrorPopup]="isShowErrorPopup"
		[labeled]="!isLabeled"
		[require]="isRequired"
		[helperText]="helperTextValue"
		[label]="labelValue"
		[error]="setError"
		[loadingState]="isLoading"
		(change)="changeEvent($event)"
		(click)="click()"
		(focusState)="setFocus($event)"
		(keyup)="inputKeyUpEvent($event)"
		(confirm)="saveOption()"
		(tryActionAgain)="tryAgain($event)"
		[componetIconStyle]="componetIconStyle"
		[componetHelperIconStyle]="componetHelperIconStyle"
		[componetIconSize]="componetIconSize"
		[hasExternalError]="hasError"
		[hasErrorMessageFeedback]="errorFeedback"
		[value]="valueInput"
	></lbca-input-text-rounded>
</main>
<ng-template cdkPortal #templateAppend="cdkPortal">
	@if (!isLabeled || isTabeled || (isEditable && isLabeled) || !isReadOnly) {
		<div
			class="select-template"
			[ngClass]="{
				'bg-gray-100 cursor-not-allowed': isDisabled,
				'mt-[18px]': helperTextValue && helperTextValue !== '',
				'mt-[12px]': helperTextValue && helperTextValue === ''
			}"
			[ngStyle]="{ width: bindProperties.width + 'px', height: bindProperties.height + 16 + 'px' }"
		>
			@if (optionFiltered.length > 0) {
				<div class="overflow-y-scroll" [ngStyle]="{ height: bindProperties.height + 'px' }">
					@for (option of optionFiltered; track option) {
						@if (option.isVisible !== false) {
							<div class="st-margin">
								<div (mousedown)="selectOption($event, option)" class="st-option">
									{{ option.label }}
								</div>
							</div>
						}
					}
				</div>
			}
			@if (optionFiltered.length === 0) {
				<span class="st-notfound">Não encontramos nenhum resultado.</span>
			}
		</div>
	}
</ng-template>
